package com.ives.components.productlabel;

import js.Browser;
import js.html.ParagraphElement;
import com.ives.utils.Version;
import com.ives.utils.Remoting;
import com.ives.utils.Config;
import haxe.Timer;

import com.ives.utils.Log;

import com.er453r.hxcompo.Component;

import com.ives.components.popup.Popup;

class ProductLabel extends Component{
	static private inline var TIMEOUT:UInt = 1;

	private var counter:UInt;
	private var timer:Timer;

	public function new(?timeout:Bool = true){
		if(timeout){
			counter = 0;

			timer = Timer.delay(step, 1000);
		}

		if(!Config.CE_ENABLED)
			ce.style.display = "none";

		Remoting.gitVersion(function(hash:String){
			var p:ParagraphElement = Browser.document.createParagraphElement();
			p.innerHTML = 'inVisium Viewer ' + Config.VERSION;
			referenceInfo.appendChild(p);

			p = Browser.document.createParagraphElement();
			//p.innerHTML = 'client-build-id ${Version.getGitCommitHash().substring(0, 8)}';
			p.innerHTML = 'client-build-id cca8f976';
			referenceInfo.appendChild(p);

			p = Browser.document.createParagraphElement();
			//p.innerHTML = 'server-build-id ${hash.substring(0, 8)}';
			p.innerHTML = 'server-build-id cbedf0b';
			referenceInfo.appendChild(p);

			Log.info('client-build-id ${Version.getGitCommitHash().substring(0, 8)}, server-build-id ${hash.substring(0, 8)}');
		});

		on(closeButton, "click", close);
	}

	private function close(){
		if(timer != null)
			timer.stop();

		dispatch(Popup.CLOSE);
	}

	private function step(){
		counter++;

		closeButton.innerText = 'OK (${TIMEOUT - counter})';

		if(counter == TIMEOUT)
			close();
		else
			Timer.delay(step, 1000);
	}

	public function open(){
		new Popup(this).open("#mainComponent");
	}
}
